import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../shared/constants/constants";
import { useCustomAxios } from "../../shared/lib/customAxios";

export const getInvoicePdf = createAsyncThunk(
    "invoice/get/pdf",
    async (reqBody: any, { rejectWithValue }) => {
        const { axiosPost } = useCustomAxios();
        let url = API_ENDPOINTS.getInvoicePdf;
        try {
            const response = await axiosPost(url, reqBody);
            const downloadURL = response.data.downloadUrl;
            const downloadLink = document.createElement("a");
            document.body.appendChild(downloadLink);
            downloadLink.href = downloadURL;
            downloadLink.download = "invoice.pdf";
            downloadLink.target = "_blank";
            downloadLink.click();
            document.body.removeChild(downloadLink);
            return { data: response.data, status: response.status };
        } catch (error: any) {
            console.log(error);
            return rejectWithValue(error.response.data.message);
        }
    }
);

export const getAllInvoice = createAsyncThunk(
    "invoice/get/all",
    async (reqBody: any, { rejectWithValue }) => {
        const { axiosPost } = useCustomAxios();
        let url = API_ENDPOINTS.getAllInvoice;
        const queryParams = reqBody.queryParams;
        const body = reqBody.body;
        Object.entries(queryParams).forEach(
            ([key, value], index) =>
                (url = url + `${index > 0 ? '&' : '?'}${key}=${encodeURIComponent(value as string ?? '')}`)
        );
        try {
            const response = await axiosPost(`${url}`, body);
            if (response.status === 200) {
                let invoices = response.data?.invoices;
                return {
                    data: {
                        invoices: invoices,
                        ...response.data
                    }, status: response.status
                };
            } else {
                throw new Error(response.data.message);
            }
        } catch (error: any) {
            return rejectWithValue(error.response.data || error.response.data.message);
        }
    }
);